import PropTypes from "prop-types";
import styled from "theme/libs/styled";

const Box = styled("div")`
    position: relative;
    overflow: hidden;
    background-color: ${({ theme }) => theme.colors.shadowGrey};
    border-radius: 8px;
    z-index: 1;

    &::after {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        transform: translateX(-100%);
        background: ${({ theme }) => theme.colors.skeletonGradient};
        animation: shimmer ${({ theme }) => theme.transitions.skeletonLoading} infinite;
        content: "";
    }

    @keyframes shimmer {
        100% {
            transform: translateX(100%);
        }
    }
`;

const TextShadow = (props) => {
    return <Box {...props} />;
};

TextShadow.propTypes = {
    height: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
    width: PropTypes.string,
};

TextShadow.defaultProps = {
    height: "18px",
    width: "64px",
};

export default TextShadow;
